import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import { trace } from 'owa-trace';
import { getFocusedFilterForTable, getSelectedTableView, MailRowDataPropertyGetter, listViewStore, } from 'owa-mail-list-store';
/**
 * Determines whether to show Focused/Other rollup in mail list.
 * @param previousRowKey previous rowKey
 * @param currentRowKey current rowKey
 */
export default function shouldShowFocusedRollup(previousRowKey, currentRowKey) {
    if (!currentRowKey) {
        trace.error('shouldShowFocusedRollup: currentRowId is not expected to be null');
        return false;
    }
    if (isMailFeatureEnabled('tri-focused-sticky-rollup')) {
        // Do not show the roll up inside list view scroll region when tri-focused-sticky-rollup is ON.
        // Instead, the rollup will be shown outside of the scroll region.
        return false;
    }
    var tableView = getSelectedTableView();
    var isFolderTable = tableView.tableQuery.type === 0 /* Folder */;
    if (!isFolderTable) {
        // Do not show focused roll up in non-folder tables
        return false;
    }
    if (getFocusedFilterForTable(tableView) === -1 /* None */) {
        // Do not show focused roll up in case of FocusedViewFilter.None
        return false;
    }
    var isCurrentRowPinned = MailRowDataPropertyGetter.getIsPinned(currentRowKey, tableView);
    if (isCurrentRowPinned === true) {
        // Do not show focused roll up if current row is pinned
        return false;
    }
    // Otherwise, when the current row is not pinned
    if (previousRowKey === null) {
        // Show focused roll up on top of list view if current row is the first row
        return true;
    }
    else {
        // If current row is not the first row, show focused roll up if the previous row is pinned
        return MailRowDataPropertyGetter.getIsPinned(previousRowKey, tableView) === true;
    }
}
/**
 * Determines whether to show focused other rollup in F/O header
 * @param tableViewId the id of the table
 */
export function shouldShowStickyFocusedRollup(tableViewId) {
    var tableView = listViewStore.tableViews.get(tableViewId);
    var focusedViewFilter = getFocusedFilterForTable(tableView);
    // Show F/O rollup in header only when
    // - tri-focused-sticky-rollup is enabled
    // - table is a folder table
    // - the FocusedViewFilter is Focused or Other
    return (isMailFeatureEnabled('tri-focused-sticky-rollup') &&
        tableView.tableQuery.type == 0 /* Folder */ &&
        (focusedViewFilter === 0 /* Focused */ ||
            focusedViewFilter === 1 /* Other */));
}
//# sourceMappingURL=shouldShowFocusedRollup.js.map